// Static fixtures for the Activity tab (UI Phase 1). Replace with GraphQL once the backend
// fields exist — see domains/load-balancing/types.ts. Shift ids reference MOCK_SHIFTS_BY_WEEK
// in schedule-calendar-mock.ts so both tabs tell one coherent story. Timestamps are relative
// to "now" so the Today/Yesterday day grouping is visible in the demo.
import type { ScheduleMoveType } from '@load-balancing/types';

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

function hoursAgo(hours: number): string {
  return new Date(Date.now() - hours * HOUR_MS).toISOString();
}

function daysAgo(days: number, hours = 0): string {
  return new Date(Date.now() - days * DAY_MS - hours * HOUR_MS).toISOString();
}

export const MOCK_SCHEDULE_MOVES: ScheduleMoveType[] = [
  {
    id: 'mv-1',
    kind: 'assignment',
    source: 'manual',
    status: 'accepted',
    workerName: 'Beth Cole',
    toShiftId: 'w2-s2',
    reasons: [],
    coverage: { before: 4, after: 5, target: 6 },
    createdAt: hoursAgo(1),
    editedBy: 'Alex Morgan',
  },
  {
    id: 'mv-2',
    kind: 'reassignment',
    source: 'system',
    status: 'accepted',
    workerName: 'Dana Pratt',
    fromShiftId: 'w1-s3',
    toShiftId: 'w2-s5',
    reasons: [
      'Closes a coverage gap on a below-target day',
      'Keeps weekly hours within the FTE band',
    ],
    coverage: { before: 3, after: 4, target: 5 },
    fteRemaining: { before: 12, after: 0 },
    createdAt: hoursAgo(3),
  },
  {
    id: 'mv-3',
    kind: 'assignment',
    source: 'system',
    status: 'rejected',
    workerName: 'Iris Wu',
    toShiftId: 'w3-s2',
    reasons: ['Highest equity score among available RNs'],
    coverage: { before: 2, after: 3, target: 4 },
    createdAt: hoursAgo(5),
  },
  {
    id: 'mv-4',
    kind: 'removal',
    source: 'manual',
    status: 'accepted',
    workerName: 'Gia Park',
    fromShiftId: 'w2-s9',
    reasons: [],
    coverage: { before: 5, after: 4, target: 5 },
    createdAt: daysAgo(1, 2),
    editedBy: 'Alex Morgan',
  },
  {
    id: 'mv-5',
    kind: 'reassignment',
    source: 'system',
    status: 'superseded',
    workerName: 'Beth Cole',
    fromShiftId: 'w1-s2',
    toShiftId: 'w2-s2',
    reasons: ['Balances weekend distribution across the period'],
    coverage: { before: 4, after: 5, target: 6 },
    createdAt: daysAgo(1, 6),
  },
  {
    id: 'mv-6',
    kind: 'correction',
    source: 'system',
    status: 'accepted',
    workerName: 'Ed Lin',
    fromShiftId: 'w2-s6',
    reasons: ['Overlaps an approved time-off block'],
    createdAt: daysAgo(2, 1),
  },
  {
    id: 'mv-7',
    kind: 'shift_addition',
    source: 'manual',
    status: 'accepted',
    toShiftId: 'w5-s1',
    reasons: [],
    createdAt: daysAgo(2, 4),
    editedBy: 'Alex Morgan',
  },
  {
    id: 'mv-8',
    kind: 'shift_cancellation',
    source: 'manual',
    status: 'accepted',
    workerName: 'Hugo Vance',
    fromShiftId: 'w1-s5',
    reasons: [],
    createdAt: daysAgo(3, 2),
    editedBy: 'Alex Morgan',
  },
];
